import { fromJS } from 'immutable'
import {
  EMPLOYEE_LEVELS_DEACTIVATE_REQUEST,
  EMPLOYEE_LEVELS_DEACTIVATE_SUCCESS,
  EMPLOYEE_LEVELS_DEACTIVATE_FAILURE,
  EMPLOYEE_LEVELS_DEACTIVATE_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case EMPLOYEE_LEVELS_DEACTIVATE_REQUEST:
      return state
        .set('isFetching', true)
    case EMPLOYEE_LEVELS_DEACTIVATE_SUCCESS:
      return state
        .set('employeeLevelsDeactivate', fromJS(action.payload.deletedEmployeeLevel))
        .set('status', 200)
        .set('message', 'Deleted Successfully.')
        .set('isFetching', false)
    case EMPLOYEE_LEVELS_DEACTIVATE_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('employeeLevelsDeactivate', fromJS(action.payload.message))
        .set('status', fromJS(action.payload.response.statusCode))
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case EMPLOYEE_LEVELS_DEACTIVATE_RESET:
      return state
        .delete('employeeLevelsDeactivate')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/employee-levels/employee-levels-deactivate-reducer.js